import { axiosApiInstance } from '@/utils/axios';
import config from '../config';
import { get } from '../utils/request';

class SessionController {
  static async authenticate(username, password) {
    const response = await axiosApiInstance.post(`${config.apiPath}/login`, { username, password });
    return response.data;
  }

  static getAuth0Keys() {
    return get(`${config.apiPath}/v1/auth0/keys`);
  }

  static async getUserInfo(token) {
    const response = await axiosApiInstance.get(`${config.apiPath}/v1/clients/info`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.data;
  }

  static async verifyToken(token) {
    return axiosApiInstance.post(`${config.apiPath}/v1/auth0/verify-token`, {
      token,
    });
  }
}
export default SessionController;
